import { t } from 'i18next';
import * as yup from 'yup';

export const signUpFormSchema = yup.object().shape({
  email: yup.string().trim().label(t('labelWorkEmail')).email().nullable().required(),
});
